import React from "react";

const Route = React.lazy(() => import("./Route"));

export const RouteAsync = (props) => (
  <React.Suspense fallback={false}>
    <Route {...props} />
  </React.Suspense>
);
export default RouteAsync;
